module.exports = __webpack_public_path__ + "img/bg-my.0ea5b51d.png";